export const SECTION_IDS = {
  dashboards: "dashboards",
  masters: "masters",
  organizationStructure: "organizationStructure",
  assetsMasters: "assetsMasters",
  rfidMaster: "rfidMaster",
  rfidReports: "rfidReports",
  reports: "reports",
  userManagement: "userManagement",
  routesPages: "routesPages",
  transactionModuleReports: "transactionModuleReports",
  complaintOperation: "complaintOperation",
  complaintManagement: "complaintManagement",
  inspectionReports: "inspectionReports",
  mobileUsers: "mobileUsers",
  attendence: "attendence",
  complaints: "complaints",
};

export const TOP_LEVEL_SECTION_IDS = [
  SECTION_IDS.dashboards,
  SECTION_IDS.masters,
  SECTION_IDS.reports,
  SECTION_IDS.userManagement,
  SECTION_IDS.mobileUsers,
  SECTION_IDS.attendence,
  SECTION_IDS.complaintManagement,
];

export const SECTION_PARENT_IDS = {
  [SECTION_IDS.organizationStructure]: SECTION_IDS.masters,
  [SECTION_IDS.assetsMasters]: SECTION_IDS.masters,
  [SECTION_IDS.rfidMaster]: SECTION_IDS.assetsMasters,
  [SECTION_IDS.routesPages]: SECTION_IDS.masters,
  [SECTION_IDS.complaints]: SECTION_IDS.complaintManagement,
  [SECTION_IDS.complaintOperation]: SECTION_IDS.complaintManagement,
  [SECTION_IDS.inspectionReports]: SECTION_IDS.reports,
  [SECTION_IDS.transactionModuleReports]: SECTION_IDS.reports,
  [SECTION_IDS.rfidReports]: SECTION_IDS.reports,
};

const 
dashboardRoutes = [
  "/sat-dashboard",
  "/scv-dashboard",
  "/gvp-dashboard",
  "/primary-dashboard",
  "/teritary-dashboard",
];

const userManagementRoutes = ["/roles", "/users", "/active-users"];

const mobileUserRoutes = [
  "/scv-drivers",
  "/primary-deployment-charge-master",
  "/secondary-deployment-incharges",
  "/transferstation-incharge",
  "/traffic-marshal",
  "/loading-equipment-driver-details",
  "/route-supervisor",
];

const organizationStructureRoutes = [
  "/organization-zone",
  "/organization-circle",
  "/organization-colony",
  "/organization-ward",
  "/shifts",
  "/transferStation",
];

const rfidMasterRoutes = ["/rfid-category", "/rfid", "/rfid-reports"];

const rfidReportRoutes = ["/rfid-reports", "/hand-held-reader-collection"];

const assetsMasterRoutes = [
  "/vehicle-type",
  "/vehicle-capacity",
  "/owner-type",
  "/vehicles",
  "/loading-equipment",
  "/Containers",
  ...rfidMasterRoutes,
];

const attendanceMasterRoutes = [
  "/operations",
  "/designations",
  "/employee",
];

const independentEngineerMasterRoutes = [
  "/ts-feedback-category",
  "/hygiene-observation",
  "/independent-engineer",
];

const attendanceRoute = [
  "/attendance-department",
  "/attendance-designation",
  "/attendance-employee",
  "/attendance-add",
  "/attendance-view",
  "/attendance-sync"
];

const mastersRoutes = [
  "/routes",
  "/deployment-locations",
  ...assetsMasterRoutes,
  ...organizationStructureRoutes,
  ...attendanceMasterRoutes,
  ...independentEngineerMasterRoutes,
  ...attendanceRoute,
];

const satsReportRoutes = ["/day_detail_report", "/trip_tssctp"];
const scvReportRoutes = ["/scv_report_circle", "/scv-deployed-trips"];
const ttrReportRoutes = [
  "/trips-tonnage-reports",
  "/hook_loader_report",
  "/container_report",
];
const gvpReportRoutes = [
  "/gvp-report",
  "/gvp-report-date",
  "/gvp-multiple-clearence",
  "/gvp-clearance-report",
];
const transactionModuleReportRoutes = [
  "/primary-deployment-transaction-report",
  "/secondary-deployment-transaction-report",
  "/deployed-hookloader-report",
  "/secondary-collection-transaction",
  "/deployed-container-transaction",
  "/all-transferstation-transaction",
  "/container-hookloader-transaction",
  "/traffic-marshal-transaction-report",
  "/tertiary-deployment-details",
  "/tertiary-trip-details",
];
const geofenceReportRoutes = [
  "/geofence-summary",
  "/geofence-vehicle-reports",
  "/geofence-vehicle-summary-reports",
];
const loadingEquipmentReportRoutes = [
  "/loading_equipment_deployment-summary-report",
  "/loading_equipment_certification-report",
  "/loading_equipment_clearance-report",
  "/contractor-wise-report",
];
const trafficMarshalReportRoutes = [
  "/unloading-wait-time",
  "/vehicle-total-weightment",
  "/live-reports",
  "/summary-reports",
];
const tertiaryReportRoutes = [
  "/deployment-report-teritary",
  "/trip-report-teritary",
  "/summary-report-teritary",
];
const attendanceReportRoutes = [
  "/attendance-summary-report",
  "/attendance-daily-report",
  "/month-wise-attendance-summary-report",
];
const grievanceReportRoutes = ["/grievance-detailed-report"];
const delhiReportRoutes = [
  "/primary-vehicle-deploy-report",
  "/ward-coverage-report",
  "/rc-deployment-report",
  "/rc-inner-report",
  "/trip-to-fcts-report",
  "/overview-of-secondary-collection-point-report",
  "/overview-of-secondary-collection-point-inner-report",
  "/hook-loader-report",
  "/hook-loader-inner-report",
  "/vehicle-coverage-report",
  "/vehicle-cleared-points-report",
  "/vehicle-balance-points-report",
  "/iec-activity-report",
];
const inspectionReportRoutes = [
  "/conditions-of-dhalao-report",
  "/conditions-of-fixed-compacting-stations-report",
  "/conditions-of-street-corner-bins-report",
  "/conditions-of-mobile-transfer-stations-report",
  "/conditions-of-auto-tippers-report",
  "/conditions-of-refuse-collector-transport-vehicles-report",
  "/conditions-of-hook-loader-vehicles-report",
];
const routeMasterRoutes = ["/collection-points", 
  "/route-master"
];
const complaintManagementRoutes = [
  "/ie-issue",
  "/sla-category",
  "/sla-user-matrix",
  "/sla-exception-rule",
  "/grievance-category",
  "/ie-kpi-type",
];
const complaintOperationRoutes = ["/ie-complaint", "/complaint"];
const allComplaintManagementRoutes = [
  ...complaintManagementRoutes,
  ...complaintOperationRoutes,
];

const reportRoutes = [
  ...satsReportRoutes,
  ...scvReportRoutes,
  ...ttrReportRoutes,
  ...gvpReportRoutes,
  ...transactionModuleReportRoutes,
  ...geofenceReportRoutes,
  ...loadingEquipmentReportRoutes,
  ...trafficMarshalReportRoutes,
  ...tertiaryReportRoutes,
  ...attendanceReportRoutes,
  ...grievanceReportRoutes,
  ...inspectionReportRoutes,
  ...delhiReportRoutes,
  ...rfidReportRoutes,
];

const masterActiveRoutePrefixes = [
  "/city-master",
  "/companies",
  "/organization",
  "/shifts",
  "/collectionpoint-details",
  "/route-master",
  "/transfer-station-master",
  "/container-master",
  "/deployment-location-master",
  "/deployment-charge-master",
  "/driver-creation",
  "/owner-type",
  "/vehicle-type",
  "/vehicle",
  "/collection-points",
  "/route-master",
];



const masterActiveExactRoutes = ["/routeTracking"];

const isMasterRouteActive = (pathname) =>
  masterActiveExactRoutes.includes(pathname) ||
  masterActiveRoutePrefixes.some((prefix) => pathname.startsWith(prefix));

const includesPermission = (permissions, permissionName) =>
  permissions?.includes(permissionName);

export const readSidebarPermissions = () => ({
  permissionNames: localStorage.getItem("loginPermissions"),
  categoryNames: localStorage.getItem("permissionCategoryNames"),
});



export const createSidebarPermissionCheckers = ({
  permissionNames,
  categoryNames,
}) => ({
  dashboard: () => includesPermission(categoryNames, "Dashboard"),
  primaryDashboard: () => includesPermission(permissionNames, "Transfer Station"),
  teritaryDashboard: () => includesPermission(permissionNames, "Secondary Deployment"),
  gvpDashboard: () => includesPermission(permissionNames, "Primary Collection"),
  scvDashboard: () => includesPermission(permissionNames, "SCVs Dashboard"),
  primaryDeploymentDashboard: () =>
    includesPermission(permissionNames, "OverView Dashboard"),
  organization: () => includesPermission(categoryNames, "Organization"),
  zone: () => includesPermission(permissionNames, "Zone"),
  circle: () => includesPermission(permissionNames, "Ward"),
  ward: () => includesPermission(permissionNames, "Ward"),
  colonies: () => includesPermission(permissionNames, "colonies"),
  vehicleType: () => includesPermission(permissionNames, "Vehicle Type"),
  vehicleCapacity: () => includesPermission(permissionNames, "Vehicle Capacity"),
  ownerType: () => includesPermission(permissionNames, "Owner Type"),
  vehicle: () => includesPermission(permissionNames, "Vehicles"),
  shifts: () => includesPermission(permissionNames, "Shifts"),
  collectionPoints: () => includesPermission(permissionNames, "Route Points"),
  collectionMaster: () => includesPermission(permissionNames, "Route Master"),
  collectionPathSummary: () =>
    includesPermission(permissionNames, "Route Path Summary"),
  routes: () => includesPermission(permissionNames, "Routes"),
  transferStation: () => includesPermission(permissionNames, "TransferStation"),
  containers: () => includesPermission(permissionNames, "Containers"),
  deploymentLocations: () =>
    includesPermission(permissionNames, "Deployment Locations"),
  secondaryDeploymentCharges: () =>
    includesPermission(permissionNames, "Deployment Incharges"),
  transferstationIncharges: () =>
    includesPermission(permissionNames, "TransferStation InCharge"),
  trafficMarshalUser: () => includesPermission(permissionNames, "Traffic Marshal,"),
  transactionReports: () =>
    includesPermission(categoryNames, "Transaction Reports"),
  trafficMarshal: () =>
    includesPermission(permissionNames, "Traffic Marshal Transaction Report"),
  teritaryDeployment: () =>
    includesPermission(permissionNames, "Secondary Deployment"),
  teritaryTrip: () => includesPermission(permissionNames, "Secondary Trip"),
  secondaryDeploymentTransaction: () =>
    includesPermission(permissionNames, "Deployment Transaction Report"),
  routePointTransaction: () =>
    includesPermission(permissionNames, "Route Point Transaction Report"),
  secondaryCollectionTransactionReport: () =>
    includesPermission(permissionNames, "Primary Collection Transaction"),
  deployedContainerTransactionReport: () =>
    includesPermission(permissionNames, "Deployed Container Transaction"),
  transferStationTransaction: () =>
    includesPermission(permissionNames, "Transfer Station Transaction"),
  hookLoaderDeploymentTransaction: () =>
    includesPermission(permissionNames, "Deployed Hookloader Transaction Report"),
  containerHookLoaderTransaction: () =>
    includesPermission(permissionNames, "Container HookLoader Transaction"),
  roles: () => includesPermission(permissionNames, "Roles"),
  users: () => includesPermission(permissionNames, "Users"),
  userManagement: () => includesPermission(categoryNames, "User Management"),
  activeUsers: () => includesPermission(permissionNames, "Active Users"),
  masterAssets: () => includesPermission(categoryNames, "Assets"),
  mobileUsers: () => includesPermission(categoryNames, "Mobile Users"),
  driverApp: () => includesPermission(permissionNames, "Drivers"),
  mobileApks: () => includesPermission(permissionNames, "Mobile APK's"),
  primaryCollectionReport: () =>
    includesPermission(permissionNames, "Primary Collection Report"),
  secondaryCollectionReport: () =>
    includesPermission(permissionNames, "Secondary Collection Report"),
  commercialCollectionReport: () =>
    includesPermission(permissionNames, "Commercial Collection Report"),
  horticultureCollectionReport: () =>
    includesPermission(
      permissionNames,
      "Horticulture Waste Collection & Transportation Report"
    ),
  drainSlitCollectionReport: () =>
    includesPermission(
      permissionNames,
      "Drain Slit C&T Waste Collection & Transportation Report"
    ),
  animalCarCollectionReport: () =>
    includesPermission(
      permissionNames,
      "Animal Car C&T Waste Collection & Transportation Repot"
    ),
  dhwCollectionReport: () =>
    includesPermission(
      permissionNames,
      "DHW C&T Waste Collection & Transportation Report"
    ),
  binClearingCollectionReport: () =>
    includesPermission(
      permissionNames,
      "Bin Clearing And Disinfection Waste Collection & Transportation Report"
    ),
  tripsAndTonnageReport: () =>
    includesPermission(permissionNames, "Trips and Tonnage Report"),
});

export const hasSidebarAccess = (accessRule, permissions) => {
  if (!accessRule) {
    return true;
  }

  const { permissionNames, categoryNames } = readSidebarPermissions();

  const hasPermission = (permissionKey) => {
    if (typeof permissions[permissionKey] === "function") {
      return permissions[permissionKey]();
    }

    return (
      includesPermission(permissionNames, permissionKey) ||
      includesPermission(categoryNames, permissionKey)
    );
  };

  if (accessRule.allOf?.length) {
    return accessRule.allOf.every(hasPermission);
  }

  if (accessRule.anyOf?.length) {
    return accessRule.anyOf.some(hasPermission);
  }

  return true;
};

export const createInitialOpenSections = (pathname) => ({
  [SECTION_IDS.dashboards]: dashboardRoutes.includes(pathname),
  [SECTION_IDS.masters]: mastersRoutes.includes(pathname),
  [SECTION_IDS.organizationStructure]: organizationStructureRoutes.includes(pathname),
  [SECTION_IDS.assetsMasters]: assetsMasterRoutes.includes(pathname),
  [SECTION_IDS.rfidMaster]: rfidMasterRoutes.includes(pathname),
  [SECTION_IDS.rfidReports]: rfidReportRoutes.includes(pathname),
  [SECTION_IDS.reports]: reportRoutes.includes(pathname),
  [SECTION_IDS.userManagement]: userManagementRoutes.includes(pathname),
  [SECTION_IDS.routesPages]: routeMasterRoutes.includes(pathname),
  [SECTION_IDS.transactionModuleReports]: transactionModuleReportRoutes.includes(pathname),
  [SECTION_IDS.inspectionReports]: inspectionReportRoutes.includes(pathname),
  [SECTION_IDS.mobileUsers]: mobileUserRoutes.includes(pathname),
  [SECTION_IDS.attendence]: false,
  [SECTION_IDS.complaintManagement]:
    allComplaintManagementRoutes.includes(pathname),
  [SECTION_IDS.complaints]: complaintManagementRoutes.includes(pathname),
  [SECTION_IDS.complaintOperation]: complaintOperationRoutes.includes(pathname),
});

export const permissionIds = {
  zone: 1,
  circle: 3,
  colonies: 157,
  vehicleType: 4,
  vehicleCapacity: 5,
  ownerType: 6,
  vehicles: 7,
  loadingEquipment: 8,
  shifts: 9,
  collectionPoints: 10,
  route: 11,
  transferStation: 12,
  containers: 13,
  roles: 23,
  users: 24,
  scvDriver: 25,
  secondaryDeploymentIncharge: 27,
  transferStationIncharge: 28,
  trafficMarshal: 50,
};

export const sidebarMenuItems = [
  // DASHBOARDS
  {
    type: "section",
    id: SECTION_IDS.dashboards,
    label: "dashboard",
    icon: "fa fa-tachometer-alt",
    access: { anyOf: ["dashboard"] },
    itemClassName: "",
    children: [
      // {
      //   type: "link",
      //   id: "primary-deployment-dashboard",
      //   label: "Primary Deployment",
      //   icon: "fa-solid fa-truck-fast",
      //   to: "/scv-dashboard",
      //   style: { display: "flex" },
      //   access: { allOf: ["dashboard", "primaryDeploymentDashboard"] },
      // },
      {
        type: "link",
        id: "primary-dashboard-overview",
        label: "Dashboard",
        icon: "fa-solid fa-gauge",
        to: "/primary-dashboard-overview",
        style: { display: "flex" },
       // access: { allOf: ["Primary Deployment"] },
         access: { allOf: ["Primary Deployment"] },
      },
      // {
      //   type: "link",
      //   id: "primary-collection-dashboard",
      //   label: "Primary Collection",
      //   icon: "fa-solid fa-recycle",
      //   to: "/gvp-dashboard",
      //   style: { display: "flex" },
      //   access: { allOf: ["dashboard", "gvpDashboard"] },
      // },
        {
          type: "link",
          id: "transfer-station-dashboard",
          label: "Transfer Station",
          icon: "fa-solid fa-warehouse",
          to: "/primary-dashboard",
          style: { display: "flex", borderRadius: "0px" },
          access: { allOf: ["Transfer-Station"] },
        },
      // {
      //   type: "link",
      //   id: "secondary-deployment-dashboard",
      //   label: "Secondary Deployment",
      //   icon: "fa-solid fa-truck-moving",
      //   to: "/teritary-dashboard",
      //   style: { display: "flex" },
      //   access: { allOf: ["dashboard", "teritaryDashboard"] },
      // },
    ],
  },
  //masters
  {
    type: "section",
    id: SECTION_IDS.masters,
    label: "masters",
    icon: "fa-solid fa-gear",
    iconClassName: "icon-white",
    activeWhen: isMasterRouteActive,
    style: { left: "1.5px" },
    textStyle: { marginLeft: "" },
    // access: {
    //   anyOf: [
    //     "organization",
    //     "masterAssets",
    //     "collectionPoints",
    //     "routes",
    //     "deploymentLocations",
    //   ],
    // },
    showDividerBeforeChildren: true,
    wrapChildrenInList: true,
    children: [
      {
        type: "section",
        id: SECTION_IDS.organizationStructure,
        label: "organizationStructure",
        icon: "fa-solid fa-sitemap",
        access: { anyOf: ["organization"] },
        collapseClassName: "level-4",
        children: [
          {
            type: "link",
            id: "organization-zone",
            label: "zones",
            icon: "fa-solid fa-map",
            to: "/organization-zone",
            style: { left: "1.5px" },
            access: { allOf: ["organization", "zone"] },
            permissionId: permissionIds.zone,
          },
          {
            type: "link",
            id: "organization-circle",
            label: "Wards",
            icon: "fa-solid fa-map-location-dot",
            to: "/organization-circle",
            style: { left: "1.5px" },
            access: { allOf: ["organization", "circle"] },
            permissionId: permissionIds.circle,
          },
          {
            type: "link",
            id: "organization-colony",
            label: "colonies",
            icon: "fa-solid fa-building-user",
            to: "/organization-colony",
            style: { left: "1.5px" },
            access: { allOf: ["organization","colonies"] },
            permissionId: permissionIds.colonies,
          },
          {
            type: "link",
            id: "shifts",
            label: "shiftMaster",
            icon: "fa-solid fa-clock",
            to: "/shifts",
            style: { left: "1.5px" },
            access: { allOf: ["organization", "shifts"] },
            permissionId: permissionIds.shifts,
          },
          {
            type: "link",
            id: "transfer-station",
            label: "transferStations",
            icon: "fa-solid fa-building",
            to: "/transferStation",
            style: { left: "1.5px" },
            access: { anyOf: ["transferStation"] },
            permissionId: permissionIds.transferStation,
          },
          // {
          //   type: "link",
          //   id: "vehicle-type",
          //   label: "vehicle_type",
          //   icon: "fa-solid fa-tags",
          //   to: "/vehicle-type",
          //   style: { left: "1.5px" },
          //   access: { allOf: ["vehicleType", "masterAssets"] },
          //   permissionId: permissionIds.vehicleType,
          // },
          // {
          //   type: "link",
          //   id: "vehicle-capacity",
          //   label: "Vehicle Capacity",
          //   icon: "fa-solid fa-weight-hanging",
          //   to: "/vehicle-capacity",
          //   style: { left: "1.5px" },
          //   access: { allOf: ["vehicleCapacity", "masterAssets"] },
          //   permissionId: permissionIds.vehicleCapacity,
          // },
          // {
          //   type: "link",
          //   id: "owner-type",
          //   label: "ownerType",
          //   icon: "fa-solid fa-user-tie",
          //   to: "/owner-type",
          //   style: { left: "1.5px" },
          //   access: { allOf: ["ownerType", "masterAssets"] },
          //   permissionId: permissionIds.ownerType,
          // },
        ],
      },
      {
        type: "section",
        id: SECTION_IDS.assetsMasters,
        label: "assetMaster",
        icon: "fa-solid fa-boxes-stacked",
        access: { anyOf: ["masterAssets", "containers"] },
        collapseClassName: "level-4",
        children: [
          
          // {
          //   type: "link",
          //   id: "vehicles",
          //   label: "vehicle",
          //   icon: "fa-solid fa-truck",
          //   to: "/vehicles",
          //   style: { left: "1.5px" },
          //   access: { allOf: ["vehicle", "masterAssets"] },
          //   permissionId: permissionIds.vehicles,
          // },
          {
            type: "link",
            id: "containers",
            label: "containers",
            icon: "fa-solid fa-cart-flatbed",
            to: "/Containers",
            style: { left: "1.5px" },
            access: { anyOf: ["containers"] },
            // permissionId: permissionIds.containers,
          },
          {
            type: "link",
            id: "rfid-category",
            label: "Asset Category",
            icon: "fa-solid fa-truck-arrow-right",
            to: "/rfid-category",
            style: { left: "1.5px" },
            access: { anyOf: ["asset-Category"] },
          },
          {
            type: "link",
            id: "rfid",
            label: "Asset Master",
            icon: "fa-solid fa-truck-pickup",
            to: "/rfid",
            style: { left: "1.5px" },
            access: { anyOf: ["asset-Master"] },
          },

        ],
      },
      {
        type: "section",
        id: SECTION_IDS.routesPages,
        label: "Routes",
        icon: "fa-solid fa-route",
        access: { anyOf: ["masterAssets", "routes"] },
        collapseClassName: "level-4",
        children: [
          {
            type: "link",
            id: "collection-points",
            label: "Route Points",
            icon: "fa-solid fa-location-dot",
            to: "/collection-points",
            style: { left: "1.5px", display: "flex" },
            access: { anyOf: ["Route Points"] },
            permissionId: permissionIds.collectionPoints,
          },
          {
            type: "link",
            id: "route-master",
            label: "Route Master",
            icon: "fa-solid fa-road",
            to: "/route-master",
            style: { left: "1.5px", display: "flex" },
            access: { anyOf: ["Route Master"] },
          },
          {
            type: "link",
            id: "route-summary-path",
            label: "Route Path Summary",
            icon: "fa-solid fa-share-nodes",
            to: "/route-summary-path",
            style: { left: "1.5px", display: "flex" },
            access: { anyOf: ["Route Path Summary"] },
          },
        ],
      },


    ],
  },
  // ATTENDANCE MANAGEMENT
  {
    type: "section",
    id: "attendance-management-parent",
    label: "Attendance Management",
    icon: "fa-solid fa-clipboard-user",
    textInset: true,
    textStyle: { paddingLeft: "0px" },
    children: [
      {
        type: "section",
        id: "attendance-management",
        label: "Attendance Master",
        icon: "fa-solid fa-clipboard-user",
        collapseClassName: "level-4",
        children: [
          {
            type: "link",
            id: "attendance-department",
            label: "Department",
            icon: "fa-solid fa-building-user",
            to: "/attendance-department",
            style: { left: "1.5px" },
            access: { anyOf: ["Department"] },
          },
          {
            type: "link",
            id: "attendance-designation",
            label: "Designation",
            icon: "fa-solid fa-id-badge",
            to: "/attendance-designation",
            style: { left: "1.5px" },
            access: { anyOf: ["Designation"] },
          },
          {
            type: "link",
            id: "attendance-employee",
            label: "Employee",
            icon: "fa-solid fa-users",
            to: "/attendance-employee",
            style: { left: "1.5px" },
            access: { anyOf: ["Employee"] },
          },
        ],
      },
      {
        type: "section",
        id: "attendance-report",
        label: "Attendance Report",
        icon: "fa-regular fa-file-lines",
        collapseClassName: "level-4",
        children: [
          {
            type: "link",
            id: "attendance-manage",
            label: "Manage Attendance",
            icon: "fa-solid fa-building-user",
            to: "/attendance-add",
            style: { left: "1.5px" },
            access: { anyOf: ["Manage Attendance"] },
          },
          {
            type: "link",
            id: "attendance-view",
            label: "View Attendance",
            icon: "fa-solid fa-users",
            to: "/attendance-view",
            style: { left: "1.5px" },
            access: { anyOf: ["View Attendance"] },
          },
          {
            type: "link",
            id: "attendance-sync",
            label: "Push NIC Attendance",
            icon: "fa-solid fa-users",
            to: "/attendance-sync",
            style: { left: "1.5px" },
            access: { anyOf: ["Push NIC Attendance"] },
          },
          {
            type: "link",
            id: "attendance-primary-man-power",
            label: "Attendance Primary Man Power",
            icon: "fa-solid fa-users",
            to: "/attendance-primary-man-power",
            style: { left: "1.5px" },
           access: { anyOf: ["Attendance Primary Man Power"] },
          },
           {
            type: "link",
            id: "attendance-secondary-man-power",
            label: "Attendance Secondary Man Power",
            icon: "fa-solid fa-users",
            to: "/attendance-secondary-man-power",
            style: { left: "1.5px" },
            access: { anyOf: ["Attendance Secondary Man Power"] },
          }
        ],
      },

    ],
  },
  //complaint management
  {
    type: "section",
    id: SECTION_IDS.complaintManagement,
    label: "Complaint Management",
    icon: "fa-solid fa-clipboard-list",
    textInset: true,
    textStyle: { paddingLeft: "0px" },
    children: [
      {
        type: "section",
        id: SECTION_IDS.complaints,
        label: "Complaints",
        icon: "fa-solid fa-exclamation-circle",
        collapseClassName: "level-4",
        children: [
            {
            type: "link",
            id: "sla-category",
            label: "SLA Category",
            icon: "fa-solid fa-exclamation-triangle",
            to: "/sla-category",
            style: { left: "1.5px" },
            access: { anyOf: ["SLA Category"] },
          },
           {
            type: "link",
            id: "grievance-category",
            label: "Grievance Category",
            icon: "fa-solid fa-list",
            to: "/grievance-category",
            style: { left: "1.5px" },
            access: { anyOf: ["Grievance Category"] },
          },
           {
            type: "link",
            id: "ie-kpi-type",
            label: "IE KPI Type",
            icon: "fa-solid fa-chart-line",
            to: "/ie-kpi-type",
            style: { left: "1.5px" },
            access: { anyOf: ["IE KPI Type"] },
          },
          {
            type: "link",
            id: "ie-issue",
            label: "IE Issue",
            icon: "fa-solid fa-exclamation-triangle",
            to: "/ie-issue",
            style: { left: "1.5px" },
            access: { anyOf: ["IE Issue"] },
          },
          {
            type: "link",
            id: "sla-user-matrix",
            label: "SLA Matrix",
            icon: "fa-solid fa-sitemap",
            to: "/sla-user-matrix",
            style: { left: "1.5px" },
            access: { anyOf: ["SLA Matrix"] },
          },
          {
            type: "link",
            id: "sla-exception-rule",
            label: "SLA Exception",
            icon: "fa-solid fa-calendar-xmark",
            to: "/sla-exception-rule",
            style: { left: "1.5px" },
            access: { anyOf: ["SLA Exception"] },
          },
         
        ],
      },
      {
        type: "section",
        id: SECTION_IDS.complaintOperation,
        label: "Complaint Operations",
        icon: "fa-solid fa-exclamation-circle",
        collapseClassName: "level-4",
        itemClassName: "complaint-operations-menu",
        textStyle: { fontSize: "12.5px" },
        children: [
          {
            type: "link",
            id: "ie-complaint",
            label: "IE Complaint",
            icon: "fa-solid fa-clipboard-list",
            to: "/ie-complaint",
            style: { left: "1.5px" },
            access: { anyOf: ["IE Complaint"] },
          },
          {
            type: "link",
            id: "complaint",
            label: "Complaint",
            icon: "fa-solid fa-exclamation-triangle",
            to: "/complaint",
            style: { left: "1.5px" },
            access: { anyOf: ["Complaint"] },
          },
        ],
      },
      //Drain Slit Complaint Report
       {
            type: "link",           
            label: "Drain Slit Complaint",
            icon: "fa-solid fa-exclamation-triangle",
            to: "/drain-slit-complaint-report",
            access: { anyOf: ["drainSlitComplaintReport"] },
            style: { left: "1.5px" },
          },
      // {
      //   type: "section",
       
      //   label: "Drain Slit Reports",
      //   icon: "fa-solid fa-ruler",
      //   style: { borderRadius: "0px", left: "1.5px" },
      //   collapseClassName: "level-4",
      //   wrapChildrenInList: true,
      //   children: [
      //     {
      //       type: "link",           
      //       label: "Drain Slit Complaint",
      //       icon: "fa-solid fa-exclamation-triangle",
      //       to: "/drain-slit-complaint-report",
      //       // access: { anyOf: ["drainSlitComplaintReport"] },
      //       style: { left: "1.5px" },
      //     },
        
      //   ],
      // },
    ],
  },
  
  // reports
  {
    type: "section",
    id: SECTION_IDS.reports,
    label: "reports",
    icon: "fa-solid fa-file-lines",
    style: { left: "1.5px" },
    textStyle: { marginLeft: "" },
    wrapChildrenInList: true,
    children: [
      {
        type: "link",
        id: "primary-collection-report",
        label: "Primary Collection Report",
        to: "/primary-collection-report",
        enabled: false,
        access: { anyOf: ["primaryCollectionReport"] },
      },
      {
        type: "link",
        id: "secondary-collection-report",
        label: "Secondary Collection Report",
        to: "/secondary-collection-report",
        enabled: false,
        access: { anyOf: ["secondaryCollectionReport"] },
      },
      {
        type: "link",
        id: "commercial-collection-report",
        label: "Commercial Collection Report",
        to: "/commercial-collection-report",
        enabled: false,
        access: { anyOf: ["commercialCollectionReport"] },
      },
      {
        type: "link",
        id: "horticulture-collection-transportation-report",
        label: "Horticulture Waste Collection & Transportation Report",
        to: "/horticulture-collection-transportation-report",
        enabled: false,
        access: { anyOf: ["horticultureCollectionReport"] },
      },
      {
        type: "link",
        id: "drainslit-collection-transportation-report",
        label: "Drain Slit C&T Waste Collection & Transportation Report",
        to: "/drainslit-C&T-transportation-report",
        enabled: false,
        access: { anyOf: ["drainSlitCollectionReport"] },
      },
      {
        type: "link",
        id: "animalcar-collection-transportation-report",
        label: "Vehicle Washing Report",
        to: "/animalcar-C&T-transportation-report",
        enabled: false,
        access: { anyOf: ["animalCarCollectionReport"] },
      },
      {
        type: "link",
        id: "complaint-report",
        label: "Collection of solid waste from Market Areas",
        to: "/complaint-report",
        enabled: false,
        access: { anyOf: ["dhwCollectionReport"] },
      },
      {
        type: "link",
        id: "dhw-collection-report",
        label: "Timely Street sweeping B/A",
        icon: "fa-solid fa-broom",
        to: "/DHW-C&T-transportation-report",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { anyOf: ["dhwCollectionReport"] },
      },
      {
        type: "link",
        id: "bin-clearing-collection-report",
        label:
          "Installation of Signage Boards on Streets/ wall painting is essential for this project, where required",
        icon: "fa-solid fa-signs-post",
        to: "/bin-clear-disinfection-transportation-report",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { anyOf: ["binClearingCollectionReport"] },
      },
      {
        type: "link",
        id: "trips-tonnage-report",
        label: "Trips and Tonnage Report",
        to: "/trips-tonnage-report",
        enabled: false,
        access: { anyOf: ["tripsAndTonnageReport"] },
      },
      {
        type: "link",
        id: "primary-vehicle-deploy-report",
        label: "Primary Vehicle Deploy",
        icon: "fa-solid fa-truck-fast",
        to: "/primary-vehicle-deploy-report",
        style: { borderRadius: "0px", left: "1.5px" },
         access: { anyOf: ["Primary Vehicle Deploy"] },
      },
      {
        type: "link",
        id: "ward-coverage-report",
        label: "Ward Coverage Report",
        icon: "fa-solid fa-map-location-dot",
        to: "/ward-coverage-report",
        style: { borderRadius: "0px", left: "1.5px" },
         access: { anyOf: ["Ward Coverage Report"] },
      },
      {
        type: "link",
        id: "rc-deployment-report",
        label: "RC Deployment Report",
        icon: "fa-solid fa-truck",
        to: "/rc-deployment-report",
        style: { borderRadius: "0px", left: "1.5px" },
         access: { anyOf: ["RC Deployment Report"] },
      },
      {
        type: "link",
        id: "trip-to-fcts-report",
        label: "Trip to FCTS",
        icon: "fa-solid fa-route",
        to: "/trip-to-fcts-report",
        style: { borderRadius: "0px", left: "1.5px" },
       access: { anyOf: ["Trip to FCTS"] }, 
      },
      {
        type: "link",
        id: "overview-of-secondary-collection-point-report",
        label: "Overview of Secondary Collection Point",
        icon: "fa-solid fa-layer-group",
        to: "/overview-of-secondary-collection-point-report",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { anyOf: ["Overview of Secondary Collection Point"] },
      },
      {
        type: "link",
        id: "hook-loader-report",
        label: "Hook Loader Report",
        icon: "fa-solid fa-truck-ramp-box",
        to: "/hook-loader-report",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { anyOf: ["Hook Loader Report"] },
      },
      {
        type: "link",
        id: "iec-activity-report",
        label: "IEC Activity Report",
        icon: "fa-solid fa-bullhorn",
        to: "/iec-activity-report",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { anyOf: ["IEC Activity Report"] },
      },

      //Inspection Module Reports
      // {
      //   type: "section",
      //   id: SECTION_IDS.inspectionReports,
      //   label: "Inspection Report",
      //   icon: "fa-solid fa-clipboard-check",
      //   style: { borderRadius: "0px", left: "1.5px" },
      //   collapseClassName: "level-4",
      //   wrapChildrenInList: true,
      //   children: [
      //     {
      //       type: "link",
      //       id: "conditions-of-dhalao-report",
      //       label: "Conditions Of Dhalao",
      //       icon: "fa-solid fa-table-list",
      //       to: "/conditions-of-dhalao-report",
      //       style: { borderRadius: "0px", left: "1.5px" },
      //         access: { anyOf: ["Conditions Of Dhalao"] },
      //     },
      //     {
      //       type: "link",
      //       id: "conditions-of-fixed-compacting-stations-report",
      //       label: "Conditions Of Fixed Compacting Station",
      //       icon: "fa-solid fa-table-cells",
      //       to: "/conditions-of-fixed-compacting-stations-report",
      //       style: { borderRadius: "0px", left: "1.5px" },
      //         access: { anyOf: ["Conditions Of Fixed Compacting Station"] },
      //     },
      //     {
      //       type: "link",
      //       id: "conditions-of-street-corner-bins-report",
      //       label: "Conditions Of Street Corner Bins",
      //       icon: "fa-solid fa-table-list",
      //       to: "/conditions-of-street-corner-bins-report",
      //       style: { borderRadius: "0px", left: "1.5px" },
      //         access: { anyOf: ["Conditions Of Street Corner Bins"] },
      //     },
      //     {
      //       type: "link",
      //       id: "conditions-of-mobile-transfer-stations-report",
      //       label: "Conditions Of Mobile Transfer Stations",
      //       icon: "fa-solid fa-truck-ramp-box",
      //       to: "/conditions-of-mobile-transfer-stations-report",
      //       style: { borderRadius: "0px", left: "1.5px" },
      //         access: { anyOf: ["Conditions Of Mobile Transfer Stations"] },
      //     },
      //     {
      //       type: "link",
      //       id: "conditions-of-auto-tippers-report",
      //       label: "Conditions Of Auto-tippers",
      //       icon: "fa-solid fa-truck",
      //       to: "/conditions-of-auto-tippers-report",
      //       style: { borderRadius: "0px", left: "1.5px" },
      //         access: { anyOf: ["Conditions Of Auto-tippers"] },
      //     },
      //     {
      //       type: "link",
      //       id: "conditions-of-refuse-collector-transport-vehicles-report",
      //       label: "Conditions Of Refuse Collector Transport Vehicles",
      //       icon: "fa-solid fa-truck-moving",
      //       to: "/conditions-of-refuse-collector-transport-vehicles-report",
      //       style: { borderRadius: "0px", left: "1.5px" },
      //         access: { anyOf: ["Conditions Of Refuse Collector Transport Vehicles"] },
      //     },
      //     {
      //       type: "link",
      //       id: "conditions-of-hook-loader-vehicles-report",
      //       label: "Conditions Of Hook-loader Vehicles",
      //       icon: "fa-solid fa-truck-ramp-box",
      //       to: "/conditions-of-hook-loader-vehicles-report",
      //       style: { borderRadius: "0px", left: "1.5px" },
      //         access: { anyOf: ["Conditions Of Hook-loader Vehicles"] },
      //     },
      //   ],
      // },
      //Transaction Module Reports
      {
        type: "section",
        id: SECTION_IDS.transactionModuleReports,
        label: "Transaction Module",
        icon: "fa-solid fa-money-bill-transfer",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { anyOf: ["transactionReports"] },
        collapseClassName: "level-4",
        wrapChildrenInList: true,
        children: [
          {
            type: "link",
            id: "secondary-deployment-transaction-report",
            label: "Deployment Transaction Report",
            icon: "fa-solid fa-clipboard-list",
            to: "/secondary-deployment-transaction-report",
            style: { borderRadius: "0px", left: "1.5px" },
            access: {
              allOf: ["secondaryDeploymentTransaction", "transactionReports"],
            },
          },
          {
            type: "link",
            id: "secondary-collection-transaction",
            label: "Collection Transaction",
            icon: "fa-solid fa-hand-holding",
            to: "/secondary-collection-transaction",
            style: { borderRadius: "0px", left: "1.5px" },
            access: {
              allOf: [
                "Collection Transaction",
                "transactionReports",
              ],
            },
          },
          {
            type: "link",
            id: "deployed-container-transaction",
            label: "Deployed Container Transaction",
            to: "/deployed-container-transaction",
            enabled: false,
            access: {
              allOf: ["deployedContainerTransactionReport", "transactionReports"],
            },
          },
          {
            type: "link",
            id: "all-transferstation-transaction",
            label: "Transfer Station Transaction",
            icon: "fa-solid fa-building-columns",
            to: "/all-transferstation-transaction",
            style: { borderRadius: "0px", left: "1.5px" },
            access: { allOf: ["transferStationTransaction", "transactionReports"] },
          },
          {
            type: "link",
            id: "deployed-hookloader-report",
            label: "Deployed Hookloader Transaction Report",
            to: "/deployed-hookloader-report",
            enabled: false,
            access: {
              allOf: ["hookLoaderDeploymentTransaction", "transactionReports"],
            },
          },
          {
            type: "link",
            id: "container-hookloader-transaction",
            label: "Container HookLoader Transaction",
            to: "/container-hookloader-transaction",
            enabled: false,
            access: {
              allOf: ["containerHookLoaderTransaction", "transactionReports"],
            },
          },
          {
            type: "link",
            id: "traffic-marshal-transaction-report",
            label: "Traffic Marshal Transaction",
            to: "/traffic-marshal-transaction-report",
            enabled: false,
            access: { allOf: ["trafficMarshal", "transactionReports"] },
          },
          // {
          //   type: "link",
          //   id: "tertiary-deployment-details",
          //   label: "Secondary Deployment",
          //   icon: "fa-solid fa-truck-ramp-box",
          //   to: "/tertiary-deployment-details",
          //   style: { borderRadius: "0px", left: "1.5px" },
          //   access: { allOf: ["teritaryDeployment", "transactionReports"] },
          // },
          // {
          //   type: "link",
          //   id: "tertiary-trip-details",
          //   label: "Secondary Trip",
          //   icon: "fa-solid fa-map-pin",
          //   to: "/tertiary-trip-details",
          //   style: { borderRadius: "0px", left: "1.5px" },
          //   access: { allOf: ["teritaryTrip", "transactionReports"] },
          // },
          // {
          //   type: "link",
          //   id: "route-point-transaction-report",
          //   label: "Route Point Transaction Report",
          //   icon: "fa-solid fa-location-crosshairs",
          //   to: "/route-point-transaction-report",
          //   style: { borderRadius: "0px", left: "1.5px" },
          //   access: { allOf: ["routePointTransaction", "transactionReports"] },
          // },
        ],
      },
      // rfid reports
      {
        type: "section",
        id: SECTION_IDS.rfidReports,
        label: "RFID Reports",
        icon: "fa-solid fa-money-bill-transfer",
        style: { borderRadius: "0px", left: "1.5px" },
        // access: { anyOf: ["rfidReports"] },
        collapseClassName: "level-4",
        wrapChildrenInList: true,
        children: [
          {
            type: "link",
            id: "rfid-reports",
            label: "RFID Report",
            icon: "fa-solid fa-dumpster",
            to: "/rfid-reports",
            style: { left: "1.5px" },
            access: { anyOf: ["RFID Report"] },
          },
          {
            type: "link",
            id: "hand-held-reader-collection",
            label: "Hand Held Reader Collection",
            icon: "fa-solid fa-mobile-screen-button",
            to: "/hand-held-reader-collection",
            style: { left: "1.5px" },
            access: { anyOf: ["Hand Held Reader Collection"] },
          },
        ],
      },
      
    ],
  },
  // USER MANAGEMENT
  {
    type: "section",
    id: SECTION_IDS.userManagement,
    label: "User Management",
    icon: "fa-solid fa-user-gear",
    textInset: true,
    textStyle: { paddingLeft: "0px" },
    access: { anyOf: ["userManagement"] },
    children: [
      {
        type: "link",
        id: "roles",
        label: "roleCreation",
        icon: "fa-solid fa-user-shield",
        to: "/roles",
        style: { display: "flex", borderRadius: "0px" },
        access: { allOf: ["roles", "userManagement"] },
        permissionId: permissionIds.roles,
      },
      {
        type: "link",
        id: "users",
        label: "userCreation",
        icon: "fa-solid fa-user-plus",
        to: "/users",
        style: { borderRadius: "0px" },
        access: { allOf: ["users", "userManagement"] },
        permissionId: permissionIds.users,
      },
      {
        type: "link",
        id: "active-users",
        label: "Active Users",
        icon: "fa-solid fa-users",
        to: "/active-users",
        style: { borderRadius: "0px" },
        access: { allOf: ["activeUsers", "userManagement"] },
        permissionId: permissionIds.users,
      },
    ],
  },
  // MOBILE USERS
  {
    type: "section",
    id: SECTION_IDS.mobileUsers,
    label: "Mobile Users",
    icon: "fa-solid fa-mobile-screen-button",
    textInset: true,
    textStyle: { paddingLeft: "0px" },
    access: { anyOf: ["mobileUsers", "trafficMarshalUser"] },
    children: [
      {
        type: "link",
        id: "scv-drivers",
        label: "Drivers",
        icon: "fa-solid fa-id-card",
        to: "/scv-drivers",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { allOf: ["driverApp", "mobileUsers"] },
        permissionId: permissionIds.scvDriver,
      },
      {
        type: "link",
        id: "secondary-deployment-incharges",
        label: "Deployment Incharges",
        icon: "fa-solid fa-user-gear",
        to: "/secondary-deployment-incharges",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { allOf: ["secondaryDeploymentCharges", "mobileUsers"] },
        permissionId: permissionIds.secondaryDeploymentIncharge,
      },
      {
        type: "link",
        id: "transferstation-incharge",
        label: "Transfer Station Incharges",
        icon: "fa-solid fa-user-check",
        to: "/transferstation-incharge",
        style: { borderRadius: "0px", left: "1.5px" },
        access: { allOf: ["transferstationIncharges", "mobileUsers"] },
        permissionId: permissionIds.transferStationIncharge,
      },
      // {
      //   type: "link",
      //   id: "route-supervisor",
      //   label: "Route Supervisor",
      //   icon: "fa-solid fa-user-pen",
      //   to: "/route-supervisor",
      //   style: { borderRadius: "0px", left: "1.5px" },
      //   access: { allOf: ["transferstationIncharges", "mobileUsers"] },
      // },
    ],
  },
  // MOBILE APK'S
  {
    type: "link",
    id: "mobile-apks",
    label: "Mobile APK's",
    icon: "fa-solid fa-file-arrow-down",
    to: "/mobile-apk's",
    style: { left: "1.5px" },
    textInset: true,
    textStyle: { paddingLeft: "0px" },
    access: { anyOf: ["mobileApks"] },
  },
];

const collectSidebarMenuPaths = (items = []) =>
  items.flatMap((item) => [
    ...(item.to ? [item.to] : []),
    ...collectSidebarMenuPaths(item.children),
  ]);

export const sidebarMenuPaths = collectSidebarMenuPaths(sidebarMenuItems);
